import { render, staticRenderFns } from "./ClientEmailNotificationFormBookingModification.vue?vue&type=template&id=180df6ea&"
import script from "./ClientEmailNotificationFormBookingModification.vue?vue&type=script&lang=js&"
export * from "./ClientEmailNotificationFormBookingModification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports